import React from 'react';


export default class Checkout extends React.Component{
        state = {
        };



    render(){
        return(
            <div style={{textAlign:'center'}}>
                <div style={{display: 'inline-block', textAlign:'center',   margin: '0 auto', fontSize: 22, fontWeight: 'bold   '}}>
                Děkujeme za nákup!
                </div>
                <div>
                    <img src="http://www.brevnovskypivovar.cz/images/logo_pivovar_brevnov.png" width="500px" alt="logo"/>
                </div>

            </div>

    )
    }
}